import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from '@reduxjs/toolkit'
import { AuthReducer }             from './reducers/AuthReducer'
import { BookingReducer }          from './reducers/BookingReducer'
import { UserReducer }             from './reducers/UserReducer'
import { VehicleReducer }          from './reducers/VehicleReducer'
import { ScheduledBookingReducer } from './reducers/ScheduledBookingReducer'
import { DepartmentReducer }       from './reducers/DepartmentReducer'
import { WorkAreaReducer }         from './reducers/WorkAreaReducer'
import {
    postScheduleBookingReducer,
    checkAvailabilityReducer,
    findNearestDriverReducer,
} from './reducers/ScheduleBookingReducer'
import {
    fetchBookingRequestsReducer,
    adminFindNearestDriverReducer,
    adminAcceptBookingReducer,
} from './reducers/AdminBookingRequestReducer'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth']
}

const rootReducer = combineReducers({
  auth: AuthReducer,
  booking:BookingReducer,
  scheduledBooking: ScheduledBookingReducer,
  user: UserReducer,
  vehicle:VehicleReducer,  
  department: DepartmentReducer,
  workArea: WorkAreaReducer, 
  postScheduleBooking:  postScheduleBookingReducer,
  checkAvailability:    checkAvailabilityReducer,
  findNearestDriver:    findNearestDriverReducer,
  adminBookingRequests:     fetchBookingRequestsReducer,
  adminFindNearestDriver:   adminFindNearestDriverReducer,
  adminAcceptBooking:       adminAcceptBookingReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    })
})

export const persistor = persistStore(store)